import { driverAssets } from '../../../constants/assets'
import type { DriverRecord } from '../../../types'

type DriverVehicleProps = {
  vehicle: DriverRecord['vehicle']
}

/** Vehicle category over the number plate. */
export const DriverVehicle = ({ vehicle }: DriverVehicleProps) => (
  <div className="flex w-full flex-col items-start font-host">
    <div className="flex w-full flex-col items-start font-medium">
      <span className="h-[19px] w-full truncate text-[14px] leading-[1.5] tracking-[-0.308px] text-dash-driver-name">
        Vehicle
      </span>
      <span className="w-full truncate text-[16px] leading-normal text-black">
        {vehicle.category}
      </span>
    </div>

    <div className="flex w-full items-center">
      <span aria-hidden className="relative block size-[20px] shrink-0 overflow-hidden">
        <span className="absolute inset-[22.11%_17.5%_24.54%_17.5%] block">
          <img alt="" className="block size-full max-w-none" src={driverAssets.plateCar} />
        </span>
      </span>
      <span className="whitespace-nowrap text-[12px] font-medium leading-[1.42] text-black">
        {vehicle.plate}
      </span>
    </div>
  </div>
)
